import { HttpAxiosRequest } from 'src/http/httpAxiosBase';
import { BaseResponse } from 'src/types';
import { SistemaTipo } from "../../../../../types/enum/enum";
import { HttpOperacionInforme } from "../../../api/httpOperacionInforme";
import {
  OperacionADCMInsert,
  schemaOperacionADCMInsert
} from '../types/dto';
import { OperacionADCM, schemaOperacionADCM } from '../types/types';
import { FilePutFields } from 'src/pages/sistema/api/file-fields';

export const getEndpoint = (url = '') => `operaciones/adcm${url}`;

export const HttpADCM = {
  get: (idOperacion: number): Promise<OperacionADCM> => {
    return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}`))
      .then(response => {
        const parsed = schemaOperacionADCM.safeParse(response);

        if (!parsed.success) {
          console.error('Validation Error (HttpADCM.get):', parsed.error.issues);
          return Promise.reject(new Error('Validation error.'));
        }

        return parsed.data;
      })
      .catch(error => {
        console.error('Network Error (HttpADCM.get):', error);
        return Promise.reject(new Error('Error obteniendo operación ADCM.'));
      });
  },

  post: (operacion: OperacionADCMInsert): Promise<BaseResponse> => {
    const parsed = schemaOperacionADCMInsert.safeParse(operacion);

    if (!parsed.success) {
      console.error('Validation Error (HttpADCM.post):', parsed.error.issues);
      return Promise.reject(new Error('Validation error.'));
    }

    const formData = new FormData();
    formData.append('operacionInsertarJson', JSON.stringify(parsed.data));

    const archivo = (operacion as any)[FilePutFields.File];
    if (archivo) {
      formData.append('file', archivo);
    }

    return HttpAxiosRequest.post(getEndpoint(), formData)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(error => {
        console.error('Network Error (HttpADCM.post):', error);
        return Promise.reject(new Error('Error insertando operación ADCM.'));
      });
  },

  descargarInforme: (idOperacion: number): Promise<any> =>
    HttpOperacionInforme.descargarInforme(idOperacion, SistemaTipo.ADCM),

  getArchivoAdjunto: (idOperacion: number): Promise<any> =>
    HttpAxiosRequest.getBlob(
      getEndpoint(`/${idOperacion}/archivos/adjunto`)
    ),

} as const;